<template lang="pug">
  card.notes-card
    label
      h3.heading {{ $t('quote.notes') }}
      textarea.square-input(:value='notes', @change='updateNotes($event.target.value)')
    label
      h3.heading {{ $t('quote.code') }}
      input.square-input(:value='promoCode', type='text', @change='updatePromoCode($event.target.value)')
    label.arrow-drop
      h3.heading {{ $t('quote.language.heading') }}
      select.square-input(:value='language', :required='true', @change='updateLanguage($event.target.value)')
        option(value="fr") {{ $t('quote.language.fr') }}
        option(value="en") {{ $t('quote.language.en') }}

</template>

<script>
import card from '@/components/common/card.vue'
import dropdown from '@/components/dashboard/dropdown.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: { card, dropdown },
  computed: {
    ...mapGetters('quote', ['notes', 'promoCode', 'language'])
  },
  methods: {
    ...mapActions('quote', ['updatePromoCode', 'updateNotes', 'updateLanguage'])
  },
  mounted () { this.updateLanguage(this.$i18n.locale) },
  updated () { this.updateLanguage(this.$i18n.locale) }
}

</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';
  .notes-card {
    color: $dark-gray;
    box-shadow: none;
    padding: 0;
    margin-top: 2em;
    background: transparent;
    max-width: 50%;
    width: 100%;
  }

  .heading {
    text-transform: none;
    margin-bottom: 1em;
    font-size: 1.1em;
    font-weight: 600;
  }

  label {
    display: block;

    & + label {
      margin-top: 1em;
    }
  }

</style>
